import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Button, Form, Modal, Spinner, Dropdown, InputGroup, Table } from 'react-bootstrap';
import $ from 'jquery';
import { AppContext } from '../App';


export const Credits = () => {
	const { credits, getCredits, setCredits, getCreditLoad, payModes, postCall, getCall, getBill, setViewBillModal } = useContext(AppContext);
	const [creditSettleModal, setCreditSettleModal] = useState(false);
	const [paymentWallet, setPaymentWallet] = useState({});
	useEffect(() => {
		if (!creditSettleModal) {
			setCreditItemId();
			setBillAmount(prev => { });
			setPaymentWallet({});
			setWalletEntry();
			setWallBalance();
		}
	}, [creditSettleModal]);
	const [billAmount, setBillAmount] = useState({});
	const [creditItemId, setCreditItemId] = useState();
	const [totalCashEntry, setTotalCashEntry] = useState(0);
	useEffect(() => {
		setTotalCashEntry(0);
		if (billAmount !== undefined && Object.keys(billAmount).length > 0) {
			Object.values(billAmount).map(amt => {
				setTotalCashEntry(prev => (parseInt(prev) + parseInt(amt)));
			});
		}
	}, [billAmount]);
	const addBillAmount = (amt, mode) => {
		if (amt !== "") {
			setBillAmount(prev => ({ ...prev, [mode]: amt }));
		} else {
			setBillAmount(prev => ({ ...prev, [mode]: 0 }));
		}
	}
	const [billSettleLoad, setBillSettleLoad] = useState(false);
	const [wallBalance, setWallBalance] = useState();
	const [getWbLoad, setGetWbLoad] = useState(false);
	const [walletEntry, setWalletEntry] = useState();
	const settleBill = () => {
		if (totalCashEntry !== undefined) {
			setBillSettleLoad(true)
			postCall('api/bnr/collect/debit/', {
				payment: billAmount,
				credit_id: creditItemId.substring(1),
			}).then((response) => {
				setBillSettleLoad(false);
				setCredits(response.data);
				setCreditSettleModal(false);
			}).catch((err) => {
				setBillSettleLoad(false);
			});
		}
	}
	const [creditHistory, setCreditHistory] = useState();
	const [creditHistoryLoad, setCreditHistoryLoad] = useState();
	const getCreditHistory = () => {
		getCall(setCreditHistoryLoad, 'api/bnr/get/debits/', setCreditHistory);
	}
	const [tabState, setTabState] = useState('home');
	const getResolved = (key) => {
		setTabState(key);
		if (key === 'history') {
			getCreditHistory();
		} else if (key === 'home') {
			getCredits();
		}
	}
	const [creditSearchResult, setCreditSearchResult] = useState();
	const [historySearchResult, setHistorySearchResult] = useState();
	const search = (s_name) => {
		if (s_name !== "") {
			if (tabState === 'home') {
				if (credits !== undefined) {
					if (Object.keys(credits).length > 0) {
						setCreditSearchResult(prev => { });
						let count = 0;
						Object.keys(credits).map(cred => {
							if (count < 50) {
								if (credits[cred].customer_name.toLowerCase().includes(s_name.toLowerCase()) || credits[cred].customer_phone.includes(s_name)) {
									setCreditSearchResult(prev => ({ ...prev, [cred]: credits[cred] }));
									count += 1;
								}
							}
						});
					}
				}
			} else if (tabState === 'history') {
				if (creditHistory !== undefined) {
					if (Object.keys(creditHistory).length > 0) {
						setHistorySearchResult(prev => { });
						let count = 0;
						Object.keys(creditHistory).map(cred => {
							if (count < 50) {
								if (creditHistory[cred].customer_name.toLowerCase().includes(s_name.toLowerCase()) || creditHistory[cred].customer_phone.includes(s_name)) {
									setHistorySearchResult(prev => ({ ...prev, [cred]: creditHistory[cred] }));
									count += 1;
								}
							}
						});
					}
				}
			}
		} else {
			setCreditSearchResult(prev => { });
			setHistorySearchResult(prev => { });
		}
	}
	useEffect(() => {
		if (tabState === 'home') {
			if ($('#credit_search_box').val() !== "") {
				search($('#credit_search_box').val());
			}
		} else if (tabState === 'history') {
			if ($('#credit_search_box').val() !== "") {
				search($('#credit_search_box').val());
			}
		}
	}, [credits, creditHistory]);
	return (
		<div className="container-fluid" >
			{/* Modern Segmented Control Navigation */}
			<div className="credits-nav-container">
				<div className="credits-nav-wrapper">
					<button
						className={`credits-nav-item ${tabState === 'home' ? 'active' : ''}`}
						onClick={() => getResolved('home')}
					>
						<i className="bi bi-credit-card-2-front"></i>
						<span>Active Credits</span>
						{credits && Object.keys(credits).length > 0 && (
							<span className="credits-nav-badge">{Object.keys(credits).length}</span>
						)}
					</button>
					<button
						className={`credits-nav-item ${tabState === 'history' ? 'active' : ''}`}
						onClick={() => getResolved('history')}
					>
						<i className="bi bi-clock-history"></i>
						<span>History</span>
					</button>
					<div className={`credits-nav-indicator ${tabState === 'history' ? 'right' : ''}`}></div>
				</div>
			</div>
			<div xs={12} sm={12} md={12} lg={12} className="service-search mb-3" >
				<Form onSubmit={(e) => { e.preventDefault() }}>
					<InputGroup>
						<Form.Control id="credit_search_box" onChange={(e) => { search(e.target.value) }} className="br-2" size="lg" type="text" placeholder="Search here" />
						<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
					</InputGroup>
				</Form>
			</div>
			<div xs={12} sm={12} md={12} lg={12} >

				{/* Content Area */}
				<div className="credits-content-area">
					{tabState === 'home' && (
						<div className="credits-tab-content">
							{
								getCreditLoad ? (
									<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
								) : (
									credits !== undefined ? (
										Object.keys(credits).length > 0 ? (
											creditSearchResult !== undefined && Object.keys(creditSearchResult).length > 0 ? (
												Object.keys(creditSearchResult).map((pk, pk_i) => (
													<Row className="closed-item bgs1 mx-0 mb-1 bdr2 br-3 py-2" key={`cred_${pk_i}`}>
														<Col xs={12} sm={6} md={8} lg={8} className="closed-item-staff" >
															<span className="f18 tp2 d-grid" >{creditSearchResult[pk].customer_name}</span>
															<span className="f14 ts2" >Date : {creditSearchResult[pk].created_date}, Time - {creditSearchResult[pk].created_time} by {creditSearchResult[pk].user_name}</span>
														</Col>
														<Col xs={12} sm={6} md={4} lg={4} className="d-flex align-items-center justify-content-end gap-2" >
															<span className='bg-total bdr0 f14 br-4 px-3 py-1 text-center' style={{ minWidth: '130px' }} >Credit : <i className="bi bi-currency-rupee"></i>{creditSearchResult[pk].amount}</span>
															<Dropdown menuRole >
																<Dropdown.Toggle variant="light" size="sm" className="br-4" ><i class="bi bi-three-dots-vertical"></i></Dropdown.Toggle>
																<Dropdown.Menu>
																	<Dropdown.Item onClick={() => {
																		getBill(creditSearchResult[pk].bill_id);
																		setViewBillModal(true);
																	}} >
																		<div className="drop-menu-item">
																			<i className="bi bi-receipt"></i>
																			<span>View Bill</span>
																		</div>
																	</Dropdown.Item>
																	<Dropdown.Item onClick={() => {
																		setCreditSettleModal(true);
																		setCreditItemId(pk);
																		setGetWbLoad(true);
																		postCall('api/ap/check/wallet/balance/from/bill/id/', { b_id: credits[pk].bill_id }).then(res => {
																			setGetWbLoad(false);
																			if (res.data.status) {
																				setWallBalance(res.data.balance);
																			}
																		}).catch(err => {
																			setGetWbLoad(false);
																		});
																	}} >
																		<div className="drop-menu-item">
																			<i className="bi bi-check-circle"></i>
																			<span>Settle</span>
																		</div>
																	</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown>
														</Col>
													</Row>
												))
											) : (
												Object.keys(credits).map((pk, pk_i) => (
													<Row className="closed-item bgs1 mx-0 mb-1 bdr1 br-3 py-2" key={`cred_${pk_i}`}>
														<Col xs={12} sm={6} md={8} lg={8} className="closed-item-staff" >
															<div className="tp2 gap-1 d-grid align-items-center" >
																<span>{credits[pk].customer_name}</span>
																<span className="f14 ts2" >Date : {credits[pk].created_date}, Time - {credits[pk].created_time}  by {credits[pk].user_name} </span>
															</div>
														</Col>
														<Col xs={12} sm={6} md={4} lg={4} className='flex-wrap align-items-center gap-2 justify-content-end'>
															<span className='bg-total bdr0 f14 br-4 px-3 py-1 text-center' style={{ minWidth: '130px' }} >Credit : <i className="bi bi-currency-rupee"></i>{credits[pk].amount}</span>
															<Dropdown menuRole >
																<Dropdown.Toggle variant="light" size="sm" className="br-4" ><i class="bi bi-three-dots-vertical"></i></Dropdown.Toggle>
																<Dropdown.Menu>
																	<Dropdown.Item onClick={() => {
																		getBill(credits[pk].bill_id);
																		setViewBillModal(true);
																	}} >
																		<div className="drop-menu-item">
																			<i className="bi bi-receipt"></i>
																			<span>View Bill</span>
																		</div>
																	</Dropdown.Item>
																	<Dropdown.Item onClick={() => {
																		setCreditSettleModal(true);
																		setCreditItemId(pk);
																		setGetWbLoad(true);
																		postCall('api/ap/check/wallet/balance/from/bill/id/', { b_id: credits[pk].bill_id }).then(res => {
																			setGetWbLoad(false);
																			if (res.data.status) {
																				setWallBalance(res.data.balance);
																			}
																		}).catch(err => {
																			setGetWbLoad(false);
																		});
																	}} >
																		<div className="drop-menu-item">
																			<i className="bi bi-check-circle"></i>
																			<span>Settle</span>
																		</div>
																	</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown>
														</Col>
													</Row>
												))
											)

										) : 'Nothing found!'
									) : ''
								)
							}
						</div>
					)}

					{tabState === 'history' && (
						<div className="credits-tab-content">
							{
								creditHistoryLoad ? (
									<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
								) : (
									creditHistory !== undefined ? (
										Object.keys(creditHistory).length > 0 ? (
											historySearchResult !== undefined && Object.keys(historySearchResult).length > 0 ? (
												Object.keys(historySearchResult).map((pk, pk_i) => (
													<Row className="closed-item bgs1 mx-0 mb-1 bdr2 br-3 py-2" key={`cred_${pk_i}`}>
														<Col xs={12} sm={12} md={12} className="closed-item-staff" >
															<span className="f18 tp2 d-grid" >{historySearchResult[pk].customer_name}, Amount = {historySearchResult[pk].amount} </span>
															<span className="f14 ts2 d-grid" >Date : {historySearchResult[pk].created_date}, Time - {historySearchResult[pk].created_time}</span>
															<span className="f14 ts2 d-grid" >Settled by {historySearchResult[pk].settled_by} on {historySearchResult[pk].settled_date} at {historySearchResult[pk].settled_time}</span>

														</Col>
													</Row>
												))
											) : (
												Object.keys(creditHistory).map((pk, pk_i) => (
													<Row className="closed-item bgs1 mx-0 mb-1 bdr2 br-3 py-2" key={`cred_${pk_i}`}>
														<Col xs={12} sm={12} md={12} className="closed-item-staff" >
															<span className="f18 tp2 d-grid" >{creditHistory[pk].customer_name}, Amount = {creditHistory[pk].amount} </span>
															<span className="f14 ts2 d-grid" >Date : {creditHistory[pk].created_date}, Time - {creditHistory[pk].created_time}</span>
															<span className="f14 ts2 d-grid" >Settled by {creditHistory[pk].settled_by} on {creditHistory[pk].settled_date} at {creditHistory[pk].settled_time}</span>

														</Col>
													</Row>
												))
											)

										) : ''
									) : ''
								)
							}
						</div>
					)}
				</div>
			</div>
			<Modal size="xl" show={creditSettleModal} backdrop="static" onHide={() => { setCreditSettleModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Settle</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						{
							getWbLoad ? (
								<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Checking wallet please wait...</span>
							) : (
								wallBalance !== undefined ? (
									<span className="d-grid f18 tp2 mb-3" >Cash available in wallet = {wallBalance}</span>
								) : (<span className="d-grid f18 tp2 mb-3" >Wallet NOT found!</span>)
							)
						}
						{
							payModes !== undefined ? (
								Object.keys(payModes).length > 0 ? (
									Object.keys(payModes).map((payMode, payMode_i) => (
										payModes[payMode].name !== 'Credit' ? (
											payModes[payMode].cw ? (
												wallBalance !== undefined ? (
													<Col xs={12} sm={6} md={3} lg={3} key={`pay_${payMode_i}`}>
														<InputGroup className="mb-3 br-2">
															<InputGroup.Text >{payModes[payMode].name}</InputGroup.Text>
															<Form.Control onChange={(e) => {
																addBillAmount(e.target.value, payMode);
																setWalletEntry(e.target.value);
															}} name="coin" type="number" min="1" />
														</InputGroup>
													</Col>
												) : ''
											) : (
												<Col xs={12} sm={6} md={3} lg={3} key={`pay_${payMode_i}`}>
													<InputGroup className="mb-3 br-2">
														<InputGroup.Text >{payModes[payMode].name}</InputGroup.Text>
														<Form.Control onChange={(e) => { addBillAmount(e.target.value, payMode) }} name="coin" type="number" min="1" />
													</InputGroup>
												</Col>
											)
										) : ''
									))
								) : ''
							) : ''
						}
					</Row>
				</Modal.Body>
				<Modal.Footer>
					{
						billSettleLoad ? (
							<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
						) : (
							creditItemId !== undefined ? (
								credits[creditItemId] !== undefined ? (
									credits[creditItemId].amount === totalCashEntry ? (
										<Button onClick={() => {
											if (wallBalance !== undefined && walletEntry !== undefined) {
												if (walletEntry <= wallBalance) {
													settleBill();
												} else {
													$.alert({
														title: 'Something went wrong',
														content: 'Wallet amount is greater than the balance available!',
														type: 'red',
													});
												}
											} else {
												settleBill();
											}
										}} className="btn-t1 br-2" ><i className="bi bi-check-lg"></i> Settle</Button>
									) : (
										<Button variant='secondary' disabled><i className="bi bi-check-lg"></i> Settle</Button>
									)
								) : ''
							) : ''
						)
					}
				</Modal.Footer>
			</Modal>


		</div>
	);
}